import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Button, Form } from "react-bootstrap";
import styled from "styled-components";
// import Chart1 from "../../components/chart/Chart1";
// import Chart2 from "../../components/chart/Chart2";
import ChartComponent from "../../components/chart/ChartComponent";
import {
  get_all_statistic,
  get_balance_by_time,
  get_loan_by_time,
  get_member_by_time,
  get_profit_of_interest_rate,
} from "../../services/report.service";
import { useStore } from "../../store";
import convertNumber from "../../helpers/convertNumber";
import moment from "moment";
import convertMonthEngToLao from "../../helpers/convertMonthEngToLao";

export default function DashboardPage() {
  // state
  // const [popup, setPopup] = useState();
  const [isLoading, setIsLoading] = useState(true);
  // const [totalPagination, setTotalPagination] = useState(0);
  const [frameTime, setFrameTime] = useState("WEEK"); // WEEK, MONTH, YEAR
  const [month, setMonth] = useState(1);
  const [statisticReportData, setStatisticReportData] = useState();
  const [memberReportData, setMemberReportData] = useState();
  const [loanReportData, setLoanReportData] = useState();
  const [balanceReportData, setBalanceReportData] = useState();
  const [interestReportData, setIntervalReportData] = useState();
  const [totalBalanceOfbranch, setTotalBalanceOfBranch] = useState(); // ຍອດເງິນໂດຍລວມ (ກີບ)

  // store
  const { token, profile, setIsLoadingDetailPage } = useStore();

  // useEffect
  useEffect(() => {
    if (frameTime === "WEEK") {
      const d = new Date();
      let _now = d.getMonth();
      setMonth(_now + 1);
    }

    getData();
  }, [frameTime, month]);

  useEffect(() => {
    // ຄິດໄລ່ຍອດເງິນລວມຂອງສາຂາ
    if (statisticReportData) {
      const {
        totalLastYearBalance,
        totalInterestRateAmount,
        totalLoanAmount,
        totalRepayment,
        totalBalance,
      } = statisticReportData?.balanceInfo;

      let total = 0;
      // ເງິນປີກ່ອນ + ເງິນຝາກ + ເງິນເກັບຄືນ + ດອກເບີຍ - ເງິນປ່ອຍກູ້
      total += totalLastYearBalance;
      total += totalBalance;
      total += totalInterestRateAmount;
      total += totalRepayment;
      total -= totalLoanAmount;

      setTotalBalanceOfBranch(total);
    }
  }, [statisticReportData]);

  // function
  const getData = async () => {
    getMemberReport();
    // getBalanceReport();
    getLoanReport();
    getIntervalReport();
    getStatisticReportData();
  };

  // ລາຍງານຈຳນວນສະມຊິກ
  const getStatisticReportData = async () => {
    try {
      setIsLoading(true);
      const data = await get_all_statistic(profile?.branchId, token);
      setStatisticReportData(data?.data);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const getMemberReport = async () => {
    try {
      setIsLoading(true);
      let findby = "?";
      findby += `frameTime=${frameTime}&month=${month}&branchId=${profile?.branchId}`;

      const data = await get_member_by_time(findby, token);
      const formatDataValue = data?.data.map((e) => e?.count);
      let formatDataLabel;
      if (frameTime === "YEAR") {
        formatDataLabel = data?.data.map((e) => convertMonthEngToLao(e?.month));
      }
      if (frameTime === "MONTH") {
        formatDataLabel = data?.data.map((e) => e?.day + "/" + month);
      }
      if (frameTime === "WEEK") {
        formatDataLabel = data?.data.map(
          (e) => moment(e?.day, "YYYY-MM-DD").format("DD") + "/" + month
        );
      }

      const value = {
        labels: formatDataLabel,
        values: [{ name: "ຈໍານວນສະມາຊີກ", data: formatDataValue }],
      };
      setMemberReportData(value);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const getLoanReport = async () => {
    try {
      setIsLoading(true);
      let findby = "?";
      findby += `frameTime=${frameTime}&month=${month}&branchId=${profile?.branchId}`;

      const data = await get_loan_by_time(findby, token);
      let formatDataLabel;
      if (frameTime === "YEAR") {
        formatDataLabel = data?.data.map((e) => convertMonthEngToLao(e?.month));
      }
      if (frameTime === "MONTH") {
        formatDataLabel = data?.data.map((e) => e?.day + "/" + month);
      }
      if (frameTime === "WEEK") {
        formatDataLabel = data?.data.map(
          (e) => moment(e?.day, "YYYY-MM-DD").format("DD") + "/" + month
        );
      }

      const formatDataValue1 = data?.data.map((e) => e?.loan);
      const formatDataValue2 = data?.data.map((e) => e?.installmentNote);
      const value = {
        labels: formatDataLabel,
        values: [
          { name: "ປ່ອຍກູ້", data: formatDataValue1 },
          { name: "ເກັບຄືນ", data: formatDataValue2 },
        ],
      };
      setLoanReportData(value);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  // const getBalanceReport = async () => {
  //   try {
  //     setIsLoading(true);
  //     let findby = "?";
  //     findby += `frameTime=${frameTime}&month=${month}&branchId=${profile?.branchId}`;

  //     const data = await get_balance_by_time(findby, token);
  //     let formatDataLabel;
  //     if (frameTime === "YEAR") {
  //       formatDataLabel = data?.data.map((e) => convertMonthEngToLao(e?.month));
  //     }
  //     if (frameTime === "MONTH") {
  //       formatDataLabel = data?.data.map((e) => e?.day + "/" + month);
  //     }
  //     if (frameTime === "WEEK") {
  //       formatDataLabel = data?.data.map(
  //         (e) => moment(e?.day, "YYYY-MM-DD").format("DD") + "/" + month
  //       );
  //     }

  //     const formatDataValue1 = data?.data.map((e) => e?.deposit);
  //     const formatDataValue2 = data?.data.map((e) => e?.withdraw);
  //     const value = {
  //       labels: formatDataLabel,
  //       values: [
  //         { name: "ເງິນອອມ", data: formatDataValue1 },
  //         { name: "ເງິນຖອນ", data: formatDataValue2 },
  //       ],
  //     };
  //     setBalanceReportData(value);
  //   } catch (err) {
  //     console.error("error", err);
  //     setIsLoading(false);
  //   }
  // };
  const getIntervalReport = async () => {
    try {
      setIsLoading(true);
      let findby = "?";
      findby += `frameTime=${frameTime}&month=${month}&branchId=${profile?.branchId}`;

      const data = await get_profit_of_interest_rate(findby, token);
      let formatDataLabel;
      if (frameTime === "YEAR") {
        formatDataLabel = data?.data.map((e) => convertMonthEngToLao(e?.month));
      }
      if (frameTime === "MONTH") {
        formatDataLabel = data?.data.map((e) => e?.day + "/" + month);
      }
      if (frameTime === "WEEK") {
        formatDataLabel = data?.data.map(
          (e) => moment(e?.day, "YYYY-MM-DD").format("DD") + "/" + month
        );
      }
      const formatDataValue1 = data?.data.map((e) => e?.interestRateAmount);
      const value = {
        labels: formatDataLabel,
        values: [{ name: "ກຳໄລຈາກດອກເບ້ຍ", data: formatDataValue1 }],
      };
      setIntervalReportData(value);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item active>ສະຖິຕິ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: 16,
        }}
      >
        <h2 style={{ marginBottom: 20 }}>ສະຖິຕິລວມ</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridGap: 10,
            gap: 10,
            marginBottom: 36,
          }}
        >
          <CardCustom>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: 20,
                gap: 10,
              }}
            >
              <div style={{ fontSize: 16, color: "#6C757D" }}>
                ຍອດເງິນໂດຍລວມ (ກີບ)
              </div>
              <div style={{ fontSize: 18, color: "#0178C1", fontWeight: 700 }}>
                {totalBalanceOfbranch
                  ? convertNumber(totalBalanceOfbranch)
                  : "-"}
              </div>
            </div>
            <div>
              {[
                {
                  title: "ເງິນສະສົມຈາກປີກ່ອນ (ກີບ)",
                  value: statisticReportData?.balanceInfo?.totalLastYearBalance
                    ? convertNumber(
                        statisticReportData?.balanceInfo?.totalLastYearBalance
                      )
                    : "-",
                },
                {
                  title: "ເງິນອອມ (ກີບ)",
                  value: statisticReportData?.balanceInfo?.totalBalance
                    ? convertNumber(
                        statisticReportData?.balanceInfo?.totalBalance
                      )
                    : "-",
                },
                {
                  title: "ປ່ອຍກູ້ (ກີບ)",
                  value: statisticReportData?.balanceInfo?.totalLoanAmount
                    ? convertNumber(
                        statisticReportData?.balanceInfo?.totalLoanAmount
                      )
                    : "-",
                },
                {
                  title: "ເກັບຄືນ (ກີບ)",
                  value: statisticReportData?.balanceInfo?.totalRepayment
                    ? convertNumber(
                        statisticReportData?.balanceInfo?.totalRepayment
                      )
                    : "-",
                },
                {
                  title: "ກຳໄລຈາກດອກເບ້ຍ (ກີບ)",
                  value: statisticReportData?.balanceInfo
                    ?.totalInterestRateAmount
                    ? convertNumber(
                        statisticReportData?.balanceInfo
                          ?.totalInterestRateAmount
                      )
                    : "-",
                },
              ]?.map((e, i) => (
                <div
                  className="list-data-profile"
                  style={{ marginBottom: 10 }}
                  key={i}
                >
                  <div>{e?.title}</div>
                  <div style={{ color: "#0178C1" }}>{e?.value}</div>
                </div>
              ))}
            </div>
          </CardCustom>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <CardCustom style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <div style={{ fontSize: 16, color: "#6C757D" }}>
                  ຈຳນວນສະມາຊິກກອງທຶນ
                </div>
                <div
                  style={{ fontSize: 18, color: "#0178C1", fontWeight: 700 }}
                >
                  {statisticReportData?.memberInfo?.totalMembers
                    ? convertNumber(
                        statisticReportData?.memberInfo?.totalMembers
                      )
                    : "-"}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // alignItems: "center",
                  flexDirection: "column",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <div style={{display: "flex", justifyContent: "space-between",width: "100%"}}>
                  <div>ອອມ (ຄົນ)</div>
                  <div style={{ color: "#0178C1", fontWeight: 700,  fontSize: 18}}>
                    {statisticReportData?.memberInfo?.totalOfBalanceMembers
                      ? convertNumber(
                          statisticReportData?.memberInfo?.totalOfBalanceMembers
                        )
                      : "-"}
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "space-between",width: "100%"}}>
                  <div>ກູ້ຢືມ (ຄົນ)</div>
                  <div style={{ color: "#0178C1", fontWeight: 700,  fontSize: 18}}>
                    {statisticReportData?.memberInfo?.totalOfLoanMembers
                      ? convertNumber(
                          statisticReportData?.memberInfo?.totalOfLoanMembers
                        )
                      : "-"}
                  </div>
                </div>
              </div>
            </CardCustom>
            {/* <CardCustom style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <div style={{ fontSize: 16, color: "#6C757D" }}>
                  ຍອດປັນຜົນລວມ (ກີບ)
                </div>
                <div
                  style={{ fontSize: 18, color: "#0178C1", fontWeight: 700 }}
                >
                  {statisticReportData?.pointInfo?.totalDividend
                    ? convertNumber(
                        statisticReportData?.pointInfo?.totalDividend
                      )
                    : "-"}
                </div>
              </div>

              <div className="list-data-profile">
                <div>ຄະແນນລວມ</div>
                <div style={{ color: "#0178C1" }}>
                  {" "}
                  {statisticReportData?.pointInfo?.totalPoint
                    ? convertNumber(statisticReportData?.pointInfo?.totalPoint)
                    : "-"}
                </div>
              </div>
            </CardCustom> */}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 20,
            marginBottom: 20,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2>ຂໍ້ມູນປະຈຳ</h2>
          </div>
          <Button
            onClick={() => setFrameTime("WEEK")}
            variant="outline"
            style={{
              width: 80,
              border:
                frameTime === "WEEK" ? "1px solid #CDE9F3" : "1px solid #DEE2E6",
              backgroundColor: frameTime === "WEEK" ? "#CDE9F3" : "#fff",
              color: frameTime === "WEEK" ? "#0178C1" : "#6C757D",
            }}
          >
            ອາທິດ
          </Button>
          <Button
            onClick={() => setFrameTime("MONTH")}
            variant="outline"
            style={{
              width: 80,
              border:
                frameTime === "MONTH"
                  ? "1px solid #CDE9F3"
                  : "1px solid #DEE2E6",
              backgroundColor: frameTime === "MONTH" ? "#CDE9F3" : "#fff",
              color: frameTime === "MONTH" ? "#0178C1" : "#6C757D",
            }}
          >
            ເດືອນ
          </Button>
          <Button
            onClick={() => setFrameTime("YEAR")}
            variant="outline"
            style={{
              width: 60,
              border:
                frameTime === "YEAR" ? "1px solid #CDE9F3" : "1px solid #DEE2E6",
              backgroundColor: frameTime === "YEAR" ? "#CDE9F3" : "#fff",
              color: frameTime === "YEAR" ? "#0178C1" : "#6C757D",
            }}
          >
            ປີ
          </Button>
        </div>

        <div
          style={{
            marginBottom: 20,
            display: frameTime === "MONTH" ? "block" : "none",
          }}
        >
          <Form.Label>ເລືອກເດືອນ</Form.Label>
          <Form.Select
            value={month}
            onChange={(e) => setMonth(e?.target.value)}
            style={{ width: 100 }}
          >
            {[
              "ມັງກອນ",
              "ກຸມພາ",
              "ມີນາ",
              "ເມສາ",
              "ພຶດສະພາ",
              "ມິຖຸນາ",
              "ກໍລະກົດ",
              "ສິງຫາ",
              "ກັນຍາ",
              "ຕຸລາ",
              "ພະຈິກ",
              "ທັນວາ",
            ].map((e, i) => (
              <option value={i + 1}>{e}</option>
            ))}
          </Form.Select>
        </div>
        <div>
          <CardCustom2>
            <div style={{ color: "#6C757D", fontSize: 16, fontWeight: 700 }}>
              ຈຳນວນສະມາຊິກ
            </div>
            <ChartComponent value={memberReportData} legend={false} />
            {/* <Chart1 /> */}
          </CardCustom2>
          {/* <CardCustom2>
            <div style={{ color: "#6C757D", fontSize: 16, fontWeight: 700 }}>
              ຈຳນວນເງິນອອມ ແລະ ຖອນ
            </div>
            <ChartComponent value={balanceReportData} />
          </CardCustom2> */}
          <CardCustom2>
            <div style={{ color: "#6C757D", fontSize: 16, fontWeight: 700 }}>
              ຈຳນວນເງິນປ່ອຍກູ້ ແລະ ເກັບຄືນ
            </div>
            <ChartComponent value={loanReportData} />
          </CardCustom2>
          <CardCustom2>
            <div style={{ color: "#6C757D", fontSize: 16, fontWeight: 700 }}>
              ກຳໄລຈາກດອກເບ້ຍ
            </div>
            <ChartComponent value={interestReportData} legend={false} />
          </CardCustom2>
        </div>
      </Card>
    </div>
  );
}

const CardCustom = styled(Card)({
  boxShadow: "1px 1px 5px rgba(0,0,0,0.1)",
  padding: 20,
});
const CardCustom2 = styled(Card)({
  boxShadow: "1px 1px 5px rgba(0,0,0,0.1)",
  padding: "20px 10px",
  marginBottom: 20,
  textAlign: "center",
});
